import { InjectedConnector } from '@moverfinance/web3';
import { CHAIN_IDS } from 'constants/chains';

export const injected = new InjectedConnector({
  supportedChainIds: [CHAIN_IDS[process.env.REACT_APP_ACTIVED_KEY as string]]
});
